import { useQuery } from "@tanstack/react-query"

import { getAllKPIs } from "@/features/kpis/api/getAllKPIs.ts"

export default function RenderKPI({ id }: { id: number }) {
  const { data, isPending, isError } = useQuery({
    queryKey: ["kpis"],
    queryFn: () => getAllKPIs(),
  })

  if (isPending) return <>Loading...</>
  if (isError) return <>Network Error</>
  const kpi = data.find((k) => k.id == id)
  return <>{kpi?.name || "N/A"}</>
}
